import React from 'react';

const BackIcon = () => (
  <svg width="45" height="27" aria-hidden="true">
    <path
      d="M15.268.732a2.5 2.5 0 0 1 .112 3.416l-.112.12-6.976 6.974L41.482 11a2.5 2.5 0 0 1 .2
      4.993l-.164.007-32.744.239 6.494 6.493a2.5 2.5 0 0 1 .112 3.416l-.112.12a2.5 2.5 0 0
      1-3.416.112l-.12-.112-11-11a2.5 2.5 0 0 1-.112-3.416l.112-.12 11-11a2.5 2.5 0 0 1 3.536 0z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default BackIcon;
